import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import GuestEditPage from '../components/GuestEditPage'
import {
  actionCreators,
  IUserEditState,
  selectCanSave,
  selectUser,
} from '../modules/guestEdit'

type IComponentState = IUserEditState

export default withRouter(
  connect(
    createStructuredSelector<ApplicationState, IComponentState>({
      canSave: selectCanSave(),
      user: selectUser(),
    }),
    actionCreators,
  )(GuestEditPage),
)
